import { PlatformInstructionsKey } from "../../LandingPage/Components/Steps/LoginAndCompletionCode";
import { MAAU0625CollGroupId } from "respondent_config_generator/src/projects/MAAU-0625";
import { LandingPageConfigBuilder } from "../../LandingPage/landingPageConfigBuilder";
import { CAIParams } from "../../queryParams";
import { setCurrentLang } from "../../i18n";
import { AppLanguage, getLanguageStrings } from "internationalisation";

const getPlatform = (groupId: MAAU0625CollGroupId): PlatformInstructionsKey => {
	switch (groupId) {
		case "MAAU-453-0625-YOUTUBE":
			return "youtube";

		case "MAAU-454-0625-TIKTOK":
			return "tiktok";

		case "MAAU-455-0625-INSTAGRAM":
			return "instagram";

		case "MAAU-456-0625-PODCAST-1":
		case "MAAU-457-0625-PODCAST-2":
			return "bvod";
		
		default:
			assertNever(groupId);
	}
}

export const configureMAAU0625Page = (
	landingPageBuilder: LandingPageConfigBuilder,
	params: CAIParams<MAAU0625CollGroupId>
) => {
	setCurrentLang(AppLanguage.en);

	landingPageBuilder.setSteps(
		LandingPageConfigBuilder.getStandardViewingSurveySteps(
			getPlatform(params.G)
		)
	);

	landingPageBuilder.setPageTitle(
		getLanguageStrings(AppLanguage.en).LandingPage.Title
	);
}